import Vue from 'vue';

/**
 * @param component - wrapped component
 * @param getCallback - callback to fetch data
 * @param submitCallback - callback on form submit
 * @param showField - show additional field
 * @returns {ExtendedVue<Vue, {}, {}, {}, Record<string, any>>|VNode}
 */
export const withGetAndSubmit = (component, { getCallback, submitCallback, showField }) => {
    return Vue.component('withGetAndSubmit', {
        functional: true,
        render(createElement, { listeners, props, children }) {
            return createElement(component, {
                props: {
                    getCallback,
                    submitCallback,
                    showField,
                    ...props
                },
                on: listeners,
                children
            })
        }
    })
};


// WEBPACK FOOTER //
// ./src/hocs/withGetAndSubmit.js